
/**
 * 상세 조회할 트윗의 ID (type이 DETAIL인 경우 필수)
- DETAIL 타입 조회 시 해당 트윗과 관련된 트윗들을 조회합니다.

 */
export type TweetIdParamParameter = number;
